"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.to-string.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _exportWarehouse = require("@/api/export-warehouse");
var _vuePropertyDecorator = require("vue-property-decorator");
var _CustomerTable = require("../customer/CustomerTable.vue");
var _FilterOrder = _interopRequireDefault(require("./components/FilterOrder.vue"));
var _ExportWarehouseModal = _interopRequireDefault(require("./components/ExportWarehouseModal.vue"));
var _exportExcel = require("./components/export-excel");
var ExportWarehouse = /*#__PURE__*/function (_Vue) {
  function ExportWarehouse() {
    var _this;
    (0, _classCallCheck2.default)(this, ExportWarehouse);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ExportWarehouse, [].concat(args));
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "data", []);
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "query", {
      page: 1,
      limit: 10
    });
    (0, _defineProperty2.default)(_this, "total", 0);
    (0, _defineProperty2.default)(_this, "filters", {});
    (0, _defineProperty2.default)(_this, "groupCustomerTrans", _CustomerTable.groupCustomerTrans);
    (0, _defineProperty2.default)(_this, "tagOptions", {
      EXPORT: {
        type: "success",
        effect: "dark"
      },
      ORDER: {
        type: "",
        effect: "dark"
      },
      GIVEAWAY: {
        type: "warning",
        effect: "dark"
      },
      DEPOSIT_ORDER: {
        type: "success",
        effect: "dark"
      },
      CONSIGN_ORDER: {
        type: "",
        effect: "dark"
      }
    });
    (0, _defineProperty2.default)(_this, "loadingExcel", false);
    (0, _defineProperty2.default)(_this, "loadingUpdateCode", false);
    (0, _defineProperty2.default)(_this, "updateModalVisible", false);
    (0, _defineProperty2.default)(_this, "form", {
      code: "",
      privateCode: ""
    });
    (0, _defineProperty2.default)(_this, "selectedRow", null);
    return _this;
  }
  (0, _inherits2.default)(ExportWarehouse, _Vue);
  return (0, _createClass2.default)(ExportWarehouse, [{
    key: "created",
    value: function created() {
      this.fetchData();
    }
  }, {
    key: "handleFilter",
    value: function handleFilter(filters) {
      this.query.page = 1;
      this.filters = filters;
      this.fetchData();
    }
  }, {
    key: "handleCellClick",
    value: function handleCellClick(row, column, cell, event) {
      // Nếu cột không phải là 'Code', gọi handleUpdate
      if (column.property !== "code") {
        this.handleUpdate(row);
      }
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(row) {
      this.$refs.modal.handleUpdate(row);
    }
  }, {
    key: "openUpdateModal",
    value: function openUpdateModal(row) {
      this.selectedRow = row;
      this.form.code = row.code;
      this.form.privateCode = row.privateCode;
      this.updateModalVisible = true;
    }
  }, {
    key: "handleUpdateCode",
    value: function () {
      var _handleUpdateCode = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.selectedRow) {
                _context.next = 15;
                break;
              }
              this.loadingUpdateCode = true;
              _context.prev = 2;
              _context.next = 5;
              return _exportWarehouse.exportWarehouseApi.updateCode(this.selectedRow.id, (0, _objectSpread2.default)({}, this.form));
            case 5:
              this.$notify({
                title: "Update code",
                message: "Successfully",
                type: "success"
              });
              this.fetchData();
              this.updateModalVisible = false;
              _context.next = 12;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](2);
            case 12:
              _context.prev = 12;
              this.loadingUpdateCode = false;
              return _context.finish(12);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 10, 12, 15]]);
      }));
      function handleUpdateCode() {
        return _handleUpdateCode.apply(this, arguments);
      }
      return handleUpdateCode;
    }()
  }, {
    key: "fetchData",
    value: function fetchData() {
      var _this2 = this;
      this.loading = true;
      _exportWarehouse.exportWarehouseApi.findAll((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.query), this.filters)).then(function (res) {
        _this2.data = res.data.exportWarehouses;
        _this2.total = res.data.total;
      }).finally(function () {
        return _this2.loading = false;
      });
    }
  }, {
    key: "handleCreate",
    value: function handleCreate() {
      this.$refs.modal.handleCreate();
    }
  }, {
    key: "handleExport",
    value: function () {
      var _handleExport = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var type,
          _args2 = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              type = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : "";
              this.fetchDataExport(type);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handleExport() {
        return _handleExport.apply(this, arguments);
      }
      return handleExport;
    }()
  }, {
    key: "fetchDataExport",
    value: function () {
      var _fetchDataExport = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(type) {
        var query, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.loadingExcel = true;
              query = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.query), this.filters);
              delete query.page;
              delete query.limit;
              _context3.prev = 4;
              _context3.next = 7;
              return _exportWarehouse.exportWarehouseApi.findAll(query);
            case 7:
              res = _context3.sent;
              (0, _exportExcel.exportWarehouseExcel)({
                data: res.data.exportWarehouses,
                type: type
              });
            case 9:
              _context3.prev = 9;
              this.loadingExcel = false;
              return _context3.finish(9);
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[4,, 9, 12]]);
      }));
      function fetchDataExport(_x) {
        return _fetchDataExport.apply(this, arguments);
      }
      return fetchDataExport;
    }()
  }]);
}(_vuePropertyDecorator.Vue);
ExportWarehouse = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    WarehouseModal: _ExportWarehouseModal.default,
    FilterOrder: _FilterOrder.default
  }
})], ExportWarehouse);
var _default = exports.default = ExportWarehouse;